<template>
    <div>
        <a role="button" class="mobile-nav-link" @click.stop="submenu.active.value = true">
            <font-awesome-icon icon="ellipsis" size="lg" class="p-2"/>
        </a>

        <div v-if="submenu.active.value"
             ref="refSubmenuBackdrop"
             class="mobile-submenu-backdrop fixed-top h-100 w-100 bg-black"/>

        <div v-if="submenu.active.value"
             ref="refSubmenu"
             class="navbar mobile-submenu justify-content-start fixed-bottom bg-white db-shadow p-4">
            <div class="d-flex justify-content-center w-100 pb-5">
                <div class="submenu-handle"/>
            </div>
            <div v-if="$can('viewAny', 'users')" class="w-100">
                <div class="w-100">
                    <h4 class="text-uppercase mx-2">{{ $t('nav.organisationGroupTitle') }}</h4>
                </div>
                <DropdownLinks :mobile-navigation="true"
                                   :class="$can('admin','system') ? 'mb-4' : ''"
                                   :links="orgLinks"/>
            </div>

            <div v-if="$can('admin','system')" class="w-100">
                <div class="w-100">
                    <h4 class="text-uppercase mx-2">{{ $t('nav.systemGroupTitle') }}</h4>
                </div>
                <DropdownLinks :mobile-navigation="true" :links="sysLinks" class="mb-4"/>
            </div>
            <div>
                <div class="w-100">
                    <h4 class="text-uppercase mx-2">{{ $t('nav.infoGroupTitle') }}</h4>
                </div>
                <DropdownLinks :mobile-navigation="true" :links="infoLinks" external-links/>
            </div>
        </div>
    </div>
</template>

<script setup>
import DropdownLinks from "~/components/layouts/DropdownLinks.vue";
import {ref} from "vue";

const refSubmenu = ref(null)
const refSubmenuBackdrop = ref(null)

defineProps({
    sysLinks: Array,
    orgLinks: Array,
    infoLinks: Array
})

const submenu = {
    active: ref(false),
    close: (e) => {
        if (refSubmenu.value && !refSubmenu.value.contains(e.target)) {
            closeMenu()
        }
    }
}

function closeMenu() {
    if (refSubmenu.value) {
        refSubmenu.value.classList.add('closing')
        refSubmenuBackdrop.value.classList.add('closing')

        setTimeout(() => {
            refSubmenu.value.classList.remove('closing')
            refSubmenuBackdrop.value.classList.remove('closing')
            submenu.active.value = false
        }, 300)
    }
}

watch(() => useRoute().fullPath, (newValue) => {
        closeMenu()
    }
)

onMounted(() => {
    document.addEventListener('click', submenu.close)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', submenu.close)
})
</script>